( function( $ ) {

    /*aos*/
    // AOS situe les elements avec offsetTop, qui ignore le body{zoom:.8} applique
    // entre 1200 et 1446px : il les croit 25% plus bas et declenche les animations
    // bien apres que la section soit passee. On rattrape le decalage element par
    // element avec data-aos-offset (le point de declenchement vaut
    // offsetTop - innerHeight + offset, donc retirer offsetTop * (1 - zoom) suffit).
    var AOS_OFFSET = 80;

    function aosZoom() {
        var body = document.body;
        var w = body.offsetWidth;
        if (!w) { return 1; }
        var z = body.getBoundingClientRect().width / w;
        return (z > 0 && z < 1.5) ? z : 1;
    }

    function aosOffsetTop(el) {
        // meme parcours que le calcul interne d'AOS
        var top = 0;
        while (el) {
            top += el.offsetTop - (el.tagName !== 'BODY' ? el.scrollTop : 0);
            el = el.offsetParent;
        }
        return top;
    }

    function aosZoomFix() {
        if (typeof AOS === 'undefined') { return; }
        var z = aosZoom();
        $('[data-aos]').each(function () {
            var off = (z === 1) ? AOS_OFFSET : Math.round(AOS_OFFSET - aosOffsetTop(this) * (1 - z));
            this.setAttribute('data-aos-offset', off);
        });
        AOS.refresh();
    }

    $(document).ready(function() {
        AOS.init({
            duration: 700,
            easing: 'ease-out-cubic',
            offset: AOS_OFFSET,
            once: true,
            // sur mobile les animations ralentissent la lecture et les fade-left/right
            // decalent les blocs de ±100px hors de l'ecran (debordement horizontal)
            disable: function () {
                return window.innerWidth < 768;
            }
        });
        aosZoomFix();
    })

    var aosZoomTimer;
    $(window).on('load resize', function () {
        clearTimeout(aosZoomTimer);
        aosZoomTimer = setTimeout(aosZoomFix, 150);
    });
    /*aos*/

    /*preloader*/
    function setCookie(name, value, minutes) {
        var expires = "";
        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + minutes * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    var prCookie = readCookie('prCookie')

    var PRLD_INTRO = 2250;
    var PRLD_HOLD = 1500;
    var PRLD_MAX = 5000;
    var PRLD_OUT = 2100;

    var $prld = $('.js-preloader');
    if (!prCookie && $prld.length) {
        setCookie('prCookie', true, 43200)
        $('body').addClass('is-preloading');

        function prldIntroLeft() {
            var el = $prld.find('.preloader__logo')[0];
            if (!el || !el.getAnimations) { return PRLD_INTRO; }
            var anim = el.getAnimations()[0];
            if (!anim) { return 0; }
            return Math.max(0, PRLD_INTRO - (anim.currentTime || 0));
        }

        var prldGone = false;

        function prldOut() {
            if (prldGone) { return; }
            prldGone = true;
            setTimeout(function () {
                $prld.addClass('is-out');
                $('body').removeClass('is-preloading');
                setTimeout(function () {
                    $prld.addClass('is-done');
                }, PRLD_OUT);
            }, prldIntroLeft() + PRLD_HOLD);
        }

        if (document.readyState === 'complete') {
            prldOut();
        } else {
            $(window).one('load', prldOut);
        }
        setTimeout(prldOut, Math.max(0, PRLD_MAX - performance.now()));
    } else {
        $prld.hide()
    }
    /*preloader*/

    /*input phone*/
    $('input.js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/

    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });
    /*header*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $('body').toggleClass('menu-opened', $(this).hasClass('active'));
        $('.js-hMenu').slideToggle();
    });


    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a').click(function(e) {
        if ($(window).width() < 992) {
            $('.js-hMenuBtn').removeClass('active');
            $('body').removeClass('menu-opened');
            $('.js-hMenu').slideUp();
        }
    });

    $('.js-hMenuArr').click(function(e) {
        if ($(window).width() < 992) {
            $(this).toggleClass('clicked');
            $(this).closest('li').toggleClass('opened', $(this).hasClass('clicked'));
            $(this).siblings('.sub-menu').slideToggle()
        }
    });
    /*header menu*/

    /*modal contact*/
    $('.js-modlBtn, a[href="#modal"]').click(function(e){
        e.preventDefault();
        $('.js-modalWindow').addClass('active');
        $('body').css('overflow', 'hidden');
    })
    $('.js-modalWindowCls').click(function(){
        $('.js-modalWindow').removeClass('active');
        $('body').css('overflow', '');
    });
    /*modal contact*/

    /*video*/
    $(document).ready(function () {
        const player = $('#vimeo-player')[0];
        $('.js-firstLoud').on('click', function () {
            const $this = $(this);
            player.muted = !player.muted;
            $this.find('.sound').removeClass('active');
            if (player.muted) {
                $this.find('.sound[data-sound="disabled"]').addClass('active');
            } else {
                $this.find('.sound[data-sound="enabled"]').addClass('active');
            }
        });
    });
    /*video*/

    /*slider*/
    $('.js-sliderSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
        $(this).closest('.js-sliderSliderWrap').find('.js-sliderSliderCounter').html(
            '<span>' + slideNum + '</span><span class="sep"> — </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });

    $('.js-slider').slick({
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: '<button class="arrow prev-arrow"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.5 7.03535H15V8.03535H14.5V7.53535V7.03535ZM0.5 8.03535C0.223858 8.03535 0 7.8115 0 7.53535C0 7.25921 0.223858 7.03535 0.5 7.03535V7.53535V8.03535ZM7.03474 0.5V0L8.03474 0V0.5L7.53474 0.5L7.03474 0.5ZM0.810138 7.90359C0.567717 8.03583 0.263996 7.9465 0.131761 7.70408C-0.000475883 7.46166 0.0888472 7.15794 0.331269 7.0257L0.570704 7.46465L0.810138 7.90359ZM8.0348 14.5V15H7.0348V14.5H7.5348H8.0348ZM14.5 7.53535V8.03535L0.570761 8.03535V7.53535V7.03535L14.5 7.03535V7.53535ZM0.570761 7.53535V8.03535H0.5V7.53535V7.03535H0.570761V7.53535ZM7.53474 0.5L8.03474 0.5C8.03474 1.46517 7.51122 2.40874 6.83424 3.23966C6.14729 4.08282 5.24358 4.88117 4.35846 5.56517C3.4704 6.25145 2.58482 6.83499 1.92269 7.24634C1.59115 7.45231 1.31451 7.6158 1.12013 7.72814C1.02292 7.78432 0.946214 7.82775 0.893425 7.85735C0.867028 7.87215 0.846606 7.88349 0.832584 7.89124C0.825573 7.89512 0.820162 7.89809 0.816403 7.90016C0.814524 7.90119 0.813058 7.90199 0.812011 7.90257C0.811488 7.90285 0.811069 7.90308 0.810758 7.90325C0.810601 7.90334 0.810446 7.90342 0.810368 7.90346C0.81024 7.90353 0.810138 7.90359 0.570704 7.46465C0.331269 7.0257 0.331221 7.02573 0.331199 7.02574C0.331226 7.02573 0.33123 7.02572 0.331285 7.02569C0.331397 7.02563 0.331613 7.02552 0.331933 7.02534C0.332573 7.02499 0.333631 7.02441 0.335099 7.0236C0.338035 7.02199 0.342612 7.01947 0.348778 7.01607C0.361109 7.00925 0.379791 6.99887 0.404401 6.98508C0.453625 6.95748 0.526535 6.91621 0.619744 6.86234C0.806212 6.75457 1.07364 6.59655 1.39498 6.39691C2.03861 5.99706 2.89404 5.43305 3.74698 4.77391C4.60288 4.11249 5.44017 3.36754 6.05898 2.60803C6.68775 1.83627 7.03474 1.11779 7.03474 0.5L7.53474 0.5ZM0.570761 7.53535C0.758092 7.07177 0.758235 7.07183 0.758404 7.0719C0.758495 7.07194 0.758692 7.07202 0.758875 7.07209C0.759243 7.07224 0.759716 7.07243 0.760294 7.07267C0.761451 7.07314 0.763028 7.07378 0.765019 7.07459C0.769002 7.07622 0.77464 7.07854 0.781881 7.08153C0.796362 7.08752 0.817256 7.09624 0.844136 7.10764C0.89789 7.13042 0.975623 7.16395 1.07391 7.20785C1.27042 7.29563 1.54951 7.42506 1.88372 7.59332C2.55089 7.92919 3.44389 8.42281 4.34008 9.05202C5.23369 9.67942 6.14794 10.4537 6.84276 11.3556C7.53813 12.2583 8.0348 13.3172 8.0348 14.5H7.5348H7.0348C7.0348 13.6076 6.66095 12.7582 6.05057 11.9659C5.43963 11.1729 4.61287 10.4654 3.76547 9.87045C2.92066 9.27731 2.07265 8.808 1.43406 8.48652C1.1154 8.32609 0.850417 8.20325 0.66608 8.12091C0.573947 8.07976 0.502062 8.04877 0.453804 8.02831C0.429679 8.01808 0.411468 8.01049 0.399595 8.00558C0.39366 8.00312 0.389309 8.00134 0.386597 8.00023C0.385241 7.99967 0.384295 7.99929 0.383764 7.99907C0.383499 7.99896 0.383338 7.9989 0.383282 7.99888C0.383254 7.99886 0.383291 7.99888 0.383277 7.99887C0.38334 7.9989 0.38343 7.99894 0.570761 7.53535Z" fill="white"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 7.03535H0L0 8.03535H0.5L0.5 7.53535L0.5 7.03535ZM14.5 8.03535C14.7761 8.03535 15 7.8115 15 7.53535C15 7.25921 14.7761 7.03535 14.5 7.03535V7.53535V8.03535ZM7.96526 0.5V0L6.96526 0V0.5L7.46526 0.5L7.96526 0.5ZM14.1899 7.90359C14.4323 8.03583 14.736 7.9465 14.8682 7.70408C15.0005 7.46166 14.9112 7.15794 14.6687 7.0257L14.4293 7.46465L14.1899 7.90359ZM6.9652 14.5V15H7.9652V14.5H7.4652H6.9652ZM0.5 7.53535L0.5 8.03535L14.4292 8.03535V7.53535V7.03535L0.5 7.03535L0.5 7.53535ZM14.4292 7.53535V8.03535H14.5V7.53535V7.03535H14.4292V7.53535ZM7.46526 0.5L6.96526 0.5C6.96526 1.46517 7.48878 2.40874 8.16576 3.23966C8.85271 4.08282 9.75642 4.88117 10.6415 5.56517C11.5296 6.25145 12.4152 6.83499 13.0773 7.24634C13.4088 7.45231 13.6855 7.6158 13.8799 7.72814C13.9771 7.78432 14.0538 7.82775 14.1066 7.85735C14.133 7.87215 14.1534 7.88349 14.1674 7.89124C14.1744 7.89512 14.1798 7.89809 14.1836 7.90016C14.1855 7.90119 14.1869 7.90199 14.188 7.90257C14.1885 7.90285 14.1889 7.90308 14.1892 7.90325C14.1894 7.90334 14.1896 7.90342 14.1896 7.90346C14.1898 7.90353 14.1899 7.90359 14.4293 7.46465C14.6687 7.0257 14.6688 7.02573 14.6688 7.02574C14.6688 7.02573 14.6688 7.02572 14.6687 7.02569C14.6686 7.02563 14.6684 7.02552 14.6681 7.02534C14.6674 7.02499 14.6664 7.02441 14.6649 7.0236C14.662 7.02199 14.6574 7.01947 14.6512 7.01607C14.6389 7.00925 14.6202 6.99887 14.5956 6.98508C14.5464 6.95748 14.4735 6.91621 14.3803 6.86234C14.1938 6.75457 13.9264 6.59655 13.605 6.39691C12.9614 5.99706 12.106 5.43305 11.253 4.77391C10.3971 4.11249 9.55983 3.36754 8.94102 2.60803C8.31225 1.83627 7.96526 1.11779 7.96526 0.5L7.46526 0.5ZM14.4292 7.53535C14.2419 7.07177 14.2418 7.07183 14.2416 7.0719C14.2415 7.07194 14.2413 7.07202 14.2411 7.07209C14.2408 7.07224 14.2403 7.07243 14.2397 7.07267C14.2385 7.07314 14.237 7.07378 14.235 7.07459C14.231 7.07622 14.2254 7.07854 14.2181 7.08153C14.2036 7.08752 14.1827 7.09624 14.1559 7.10764C14.1021 7.13042 14.0244 7.16395 13.9261 7.20785C13.7296 7.29563 13.4505 7.42506 13.1163 7.59332C12.4491 7.92919 11.5561 8.42281 10.6599 9.05202C9.76631 9.67942 8.85206 10.4537 8.15724 11.3556C7.46187 12.2583 6.9652 13.3172 6.9652 14.5H7.4652H7.9652C7.9652 13.6076 8.33905 12.7582 8.94943 11.9659C9.56037 11.1729 10.3871 10.4654 11.2345 9.87045C12.0793 9.27731 12.9274 8.808 13.5659 8.48652C13.8846 8.32609 14.1496 8.20325 14.3339 8.12091C14.4261 8.07976 14.4979 8.04877 14.5462 8.02831C14.5703 8.01808 14.5885 8.01049 14.6004 8.00558C14.6063 8.00312 14.6107 8.00134 14.6134 8.00023C14.6148 7.99967 14.6157 7.99929 14.6162 7.99907C14.6165 7.99896 14.6167 7.9989 14.6167 7.99888C14.6167 7.99886 14.6167 7.99888 14.6167 7.99887C14.6167 7.9989 14.6166 7.99894 14.4292 7.53535Z" fill="white"/> </svg></button>',
        appendArrows: $('.js-sliderSliderWrap').find('.js-sliderSliderArrows')
    });
    /*slider*/

    /*main techs*/
    // dir : 'down' | 'up' | '' — sens du changement, sert a orienter l'animation
    function mainTechsGo($list, i, dir) {
        var $section = $list.closest('.main-techs');
        var $items = $list.find('.main-techs-list-item');
        if (!$items.filter('[data-tech="' + i + '"]').length) { return; }

        $list.removeClass('is-down is-up');
        if (dir) {
            // reflow : sans lui le navigateur ne rejoue pas l'animation
            // quand on enchaine deux changements dans le meme sens
            void $list[0].offsetWidth;
            $list.addClass(dir === 'down' ? 'is-down' : 'is-up');
        }

        $items.removeClass('active').filter('[data-tech="' + i + '"]').addClass('active');

        var $bls = $section.find('.js-mainTechsBls');
        $bls.find('.main-techs-bl')
            .removeClass('active').filter('[data-tech="' + i + '"]').addClass('active');
        // le texte de la fenetre est commun, seul le bouton change
        $bls.find('.main-techs-bl-pop-btn')
            .removeClass('active').filter('[data-tech="' + i + '"]').addClass('active');
    }

    $('.js-mainTechsList').on('click', '.main-techs-list-item', function(){
        var $list = $(this).closest('.js-mainTechsList');
        var $items = $list.find('.main-techs-list-item');
        var from = $items.index($items.filter('.active'));
        var to = $items.index(this);
        mainTechsGo($list, $(this).data('tech'), (to > from) ? 'down' : (to < from ? 'up' : ''));
    });

    // Molette au survol de la carte : on change de technologie au lieu de faire
    // defiler la page. Arrive au premier / dernier element, la molette reprend
    // son role normal et la page defile.
    var TECHS_STEP = 45;   // delta cumule necessaire pour changer d'element
    var TECHS_LOCK = 500;  // pause apres un changement (inertie du pave tactile)

    // Firefox donne le delta en lignes (deltaMode 1) ou en pages (2) :
    // on ramene tout en pixels pour que le seuil garde le meme sens.
    function mainTechsDelta(e) {
        if (e.deltaMode === 1) { return e.deltaY * 16; }
        if (e.deltaMode === 2) { return e.deltaY * window.innerHeight; }
        return e.deltaY;
    }

    function mainTechsWheelOn() {
        if (!window.matchMedia) { return false; }
        return window.matchMedia('(min-width: 992px)').matches
            && window.matchMedia('(pointer: fine)').matches;
    }

    $('.main-techs-card').each(function () {
        var card = this;
        var $list = $(card).find('.js-mainTechsList');
        if (!$list.length || $list.find('.main-techs-list-item').length < 2) { return; }

        var delta = 0;
        var last = 0;

        card.addEventListener('wheel', function (e) {
            if (!mainTechsWheelOn() || e.ctrlKey) { return; }

            var $items = $list.find('.main-techs-list-item');
            var cur = $items.index($items.filter('.active'));
            if (cur < 0) { cur = 0; }

            var d = mainTechsDelta(e);
            if (!d) { return; }
            var dir = (d > 0) ? 1 : -1;
            var next = cur + dir;
            if (next < 0 || next >= $items.length) {
                // extremite atteinte : on rend la molette a la page
                delta = 0;
                return;
            }

            e.preventDefault();

            var now = Date.now();
            if (now - last < TECHS_LOCK) { return; }
            if (delta * dir < 0) { delta = 0; }  // changement de sens
            delta += d;
            if (Math.abs(delta) < TECHS_STEP) { return; }

            delta = 0;
            last = now;
            mainTechsGo($list, $items.eq(next).data('tech'), (dir > 0) ? 'down' : 'up');
        }, { passive: false });
    });
    /*main techs*/

    /*main second — animations au scroll*/
    var $second = $('.js-mainSecond');
    if ($second.length) {
        // anim-ready n'est pose que si le js tourne : sans lui la section
        // reste visible telle quelle. Les delais "chaotiques" sont dans le scss.
        $second.addClass('anim-ready');

        function mainSecondFrame() {
            if ($second.hasClass('animated')) { return; }
            if ($(window).scrollTop() + $(window).height() * 0.85 > $second.offset().top) {
                $second.addClass('animated');
                $(window).off('scroll resize', mainSecondFrame);
            }
        }

        $(window).on('scroll resize load', mainSecondFrame);
        mainSecondFrame();
    }
    /*main second — animations au scroll*/

    /*main contcta — animations au scroll*/
    var $contcta = $('.js-mainContcta');
    if ($contcta.length) {
        function mainContctaFrame() {
            if ($contcta.hasClass('animated')) { return; }
            if ($(window).scrollTop() + $(window).height() * 0.85 > $contcta.offset().top + ($contcta.height() / 2)) {
                $contcta.addClass('animated');
                $(window).off('scroll resize', mainContctaFrame);
            }
        }

        $(window).on('scroll resize load', mainContctaFrame);
        mainContctaFrame();
    }
    /*main contcta — animations au scroll*/

    /*main soins — parallaxe*/
    var $soinsImg = $('.js-mainSoinsImg');
    if ($soinsImg.length) {
        var soinsTick = false;

        function mainSoinsFrame() {
            soinsTick = false;
            if ($(window).width() < 768) {
                $soinsImg.find('img').css('transform', '');
                return;
            }

            var rect = $soinsImg[0].getBoundingClientRect();
            var wh = $(window).height();
            if (rect.bottom < 0 || rect.top > wh) { return; }

            // -1 (section sous l'ecran) .. 1 (section au-dessus)
            var p = ((wh - rect.top) / (wh + rect.height)) * 2 - 1;
            p = Math.max(-1, Math.min(1, p));
            $soinsImg.find('img').css('transform', 'translate3d(0,' + (p * 8) + '%,0)');
        }

        $(window).on('scroll resize load', function () {
            if (soinsTick) { return; }
            soinsTick = true;
            window.requestAnimationFrame(mainSoinsFrame);
        });
        mainSoinsFrame();
    }
    /*main soins — parallaxe*/

    /*main traits*/
    var $traitsSlider = $('.js-mainTraitsSlider');
    if ($traitsSlider.length) {
        $traitsSlider.on('init afterChange', function(e, slick, cur){
            var i = (cur === undefined) ? slick.currentSlide : cur;
            $('.js-mainTraitsTabs').find('.main-traits-tabs-btn')
                .removeClass('active')
                .filter('[data-slide="' + i + '"]').addClass('active');
        });
        $traitsSlider.slick({
            arrows: false,
            dots: false,
            infinite: true,
            centerMode: true,
            centerPadding: '0px',
            variableWidth: false,
            autoplay: true,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            speed: 400
        });
        $('.js-mainTraitsTabs').on('click', '.main-traits-tabs-btn', function(){
            $traitsSlider.slick('slickGoTo', $(this).data('slide'));
        });
        $('.js-mainTraits').on('click', '.js-mainTraitsCol:not(.slick-center)', function(e){
            $traitsSlider.slick('slickGoTo', $(this).data('slick-index'));
        });
    }
    /*main traits*/

    /*wpcf7 thankyou*/
    document.addEventListener('wpcf7mailsent', function (event) {
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    }, false);
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*wpcf7 thankyou*/

    /*jsel — custom select*/
    function jselSync($jsel) {
        var $sel = $jsel.data('sel');
        var i = $sel.prop('selectedIndex');
        var $opt = $sel.find('option').eq(i);
        var blank = ($opt.attr('value') === '' || $opt.attr('value') === undefined);
        $jsel.find('.jsel-btn-txt').text($opt.text());
        $jsel.toggleClass('placeholder', blank);
        $jsel.find('.jsel-list-item').removeClass('active').filter('[data-i="' + i + '"]').addClass('active');
    }

    $('.js-jsel').each(function(){
        var $wrap = $(this);
        var $sel = $wrap.find('select');
        if (!$sel.length || $wrap.find('.jsel').length) {
            return;
        }

        var arr = '<svg viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var chk = '<svg viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1 5.5L5 9.5L13 1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        var $jsel = $('<div class="jsel"></div>');
        var $btn = $('<button type="button" class="jsel-btn" aria-expanded="false"><span class="jsel-btn-txt"></span><span class="jsel-btn-arr">' + arr + '</span></button>');
        var $list = $('<div class="jsel-list"></div>');

        $sel.find('option').each(function(i){
            var $opt = $(this);
            if ($opt.attr('value') === '' || $opt.attr('value') === undefined) {
                return;
            }
            var $item = $('<button type="button" class="jsel-list-item" data-i="' + i + '"><span class="jsel-list-item-txt"></span><span class="jsel-list-item-ico">' + chk + '</span></button>');
            $item.find('.jsel-list-item-txt').text($opt.text());
            $list.append($item);
        });

        $sel.addClass('jsel-native').attr('tabindex', '-1');
        $jsel.append($btn).append($list).appendTo($wrap);
        $jsel.data('sel', $sel);
        jselSync($jsel);
    });

    $(document).on('click', '.jsel-btn', function(e){
        e.preventDefault();
        var $jsel = $(this).closest('.jsel');
        var opened = !$jsel.hasClass('opened');
        $('.jsel').removeClass('opened').find('.jsel-btn').attr('aria-expanded', 'false');
        $jsel.toggleClass('opened', opened);
        $(this).attr('aria-expanded', opened ? 'true' : 'false');
    });

    $(document).on('click', '.jsel-list-item', function(e){
        e.preventDefault();
        var $jsel = $(this).closest('.jsel');
        $jsel.data('sel').prop('selectedIndex', $(this).data('i')).trigger('change');
        $jsel.removeClass('opened').find('.jsel-btn').attr('aria-expanded', 'false');
        jselSync($jsel);
    });

    $(document).on('click', function(e){
        if (!$(e.target).closest('.jsel').length) {
            $('.jsel').removeClass('opened').find('.jsel-btn').attr('aria-expanded', 'false');
        }
    });
    /*jsel*/

    /*page contacts thankyou*/
    document.addEventListener('wpcf7mailsent', function (event) {
        $(event.target).closest('.js-contactsCont').addClass('sent');
        $('.jsel').each(function(){
            jselSync($(this));
        });
    }, false);
    /*page contacts thankyou*/

    /*page cabinet — valeurs stack*/
    var $cabStack = $('.js-cabValsStack');
    if ($cabStack.length) {
        var cabStack = $cabStack[0];
        var cabDeck = cabStack.querySelector('.js-cabValsDeck');
        var $cabCards = $cabStack.find('.page-cabinet-vals-bl');
        var cabCount = $cabCards.length;
        var CAB_GAP = 50;   // ecart demande entre le coin bas de la carte qui part et le haut de la suivante
        var CAB_ROT = 32;   // angle du pivot en fin de course
        var cabOpen = false;
        var cabTimer = null;

        // repos apres le retournement : la carte de tete est droite, les suivantes debordent un peu
        function cabRest(i) {
            if (i === 0) { return { x: 0, y: 0, r: 0 }; }
            var s = (i % 2) ? -1 : 1;
            return { x: s * (6 + i * 3), y: i * 5, r: s * (5 + (i - 1) * 2) };
        }

        // decalage vertical en fin de pivot : le coin bas de la carte reste a 50px
        // au-dessus du haut de la carte suivante (coin bas droit si elle tourne dans
        // le sens des aiguilles, coin bas gauche dans l'autre sens : meme calcul)
        function cabEndY(w, h, deg) {
            var a = Math.abs(deg) * Math.PI / 180;
            return -CAB_GAP - h / 2 - (w / 2) * Math.sin(a) - (h / 2) * Math.cos(a);
        }

        function cabReset() {
            if (cabTimer) { clearTimeout(cabTimer); cabTimer = null; }
            cabOpen = false;
            $cabStack.removeClass('is-flip is-spread is-live');
            $cabCards.attr('style', '');
        }

        function cabOpenDeck() {
            if (cabOpen) { return; }
            cabOpen = true;
            $cabStack.addClass('is-flip');
            // le depliage n'intervient qu'une fois le dos retourne
            cabTimer = setTimeout(function () {
                cabTimer = null;
                $cabStack.addClass('is-spread');
                cabValsFrame();
            }, 1100);
        }

        function cabValsFrame() {
            if ($(window).width() < 992 || cabCount === 0) {
                $cabStack.removeClass('is-live');
                $cabCards.attr('style', '');
                return;
            }

            var winH = $(window).height();
            var rect = cabStack.getBoundingClientRect();
            var travel = rect.height - winH;
            var hold = winH * 0.6;   // temps mort pendant le retournement et le depliage
            var spread = $cabStack.hasClass('is-spread');
            var q = 0;

            if (spread && travel > hold) {
                q = (-rect.top - hold) / ((travel - hold) / cabCount);
                q = Math.max(0, Math.min(cabCount, q));
            }

            $cabStack.toggleClass('is-live', q > 0.001);

            // body{zoom} : rect est a l'echelle de l'ecran, les transforms en px de mise en page
            var scale = (cabDeck && cabDeck.offsetWidth) ? (cabDeck.getBoundingClientRect().width / cabDeck.offsetWidth) : 1;
            var cw = $cabCards[0].offsetWidth;
            var ch = $cabCards[0].offsetHeight;
            var endY = cabEndY(cw, ch, CAB_ROT);
            var outY = endY - winH / (scale || 1) - ch;

            $cabCards.each(function (i) {
                var rest = cabRest(i);
                var dir = (i % 2 === 0) ? 1 : -1;   // 1re carte dans le sens des aiguilles, la 2e a l'inverse, etc.
                // la carte se redresse au fur et a mesure qu'elle arrive en tete du paquet
                var lead = Math.max(0, Math.min(1, q - (i - 1)));
                var rx = spread ? rest.x * (1 - lead) : 0;
                var ry = spread ? rest.y * (1 - lead) : 0;
                var rr = spread ? rest.r * (1 - lead) : 0;
                var x = rx;
                var y = ry;
                var r = rr;
                // la derniere carte n'a pas de suivante : elle reste affichee
                var t = (i === cabCount - 1) ? 0 : q - i;

                if (t > 0) {
                    // 1er temps : la carte monte en pivotant jusqu'a sa position calculee
                    var t1 = Math.min(t, 1);
                    x = rx * (1 - t1);
                    y = ry + (endY - ry) * t1;
                    r = rr + (dir * CAB_ROT - rr) * t1;

                    // 2e temps : elle poursuit sa course pendant que la suivante demarre
                    if (t > 1) {
                        var t2 = Math.min(t - 1, 1);
                        x = 0;
                        y = endY + (outY - endY) * t2;
                        r = dir * CAB_ROT * (1 + t2 * 0.8);
                    }
                }

                this.style.zIndex = String(cabCount - i);
                this.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) rotate(' + r.toFixed(2) + 'deg)';
            });
        }

        // le retournement se declenche quand la carte est entierement dans l'ecran
        if ('IntersectionObserver' in window && cabDeck) {
            new IntersectionObserver(function (entries) {
                for (var n = 0; n < entries.length; n++) {
                    var e = entries[n];
                    if ($(window).width() < 992) { continue; }
                    if (e.intersectionRatio > 0.99) {
                        cabOpenDeck();
                    } else if (e.intersectionRatio === 0 && e.boundingClientRect.top > 0) {
                        cabReset();   // on est remonte au-dessus de la section : l'effet se rejoue
                    }
                }
            }, { threshold: [0, 0.99, 1] }).observe(cabDeck);
        } else {
            cabOpen = true;
            $cabStack.addClass('is-flip is-spread');
        }

        $(window).on('scroll resize load', cabValsFrame);
        cabValsFrame();
    }

    $('.js-cabValsArr').click(function () {
        var $stack = $('.js-cabValsStack');
        if (!$stack.length) { return; }
        $('html, body').animate({ scrollTop: $stack.offset().top }, 600);
    });
    /*page cabinet — valeurs stack*/

    /*page cabinet — galerie*/
    $(document).ready(function () {
        var $galRows = $('.js-cabGalRow');

        function cabGalBuild() {
            if (!$galRows.length) { return; }

            if ($(window).width() > 991) {
                // desktop : deux rangees en defilement continu (marquee)
                var dir = 'left';
                $galRows.each(function () {
                    var $row = $(this);
                    if ($row.data('slick')) {
                        $row.find('.page-cabinet-gal-row').slick('unslick');
                    }
                    if (!$row.data('marquee-on')) {
                        $row.marquee({
                            startVisible: true,
                            duration: 25000,
                            gap: 0,
                            delayBeforeStart: 0,
                            direction: dir,
                            duplicated: true,
                            duplicateCount: 3,
                            pauseOnHover: true
                        });
                        $row.data('marquee-on', true).data('marquee-dir', dir);
                    }
                    dir = (dir === 'left') ? 'right' : 'left';
                });
            }
        }

        cabGalBuild();

        // compteur + fleches
        var $galCnt = $('.js-cabGalCnt');
        var $galArrows = $('.js-cabGalArrows');
        if ($galArrows.length) {
            var arrPrev = '<button type="button" class="page-cabinet-gal-nav-arr prev js-cabGalPrev" aria-label="Précédent"><svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13 5H1M5 1L1 5l4 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
            var arrNext = '<button type="button" class="page-cabinet-gal-nav-arr next js-cabGalNext" aria-label="Suivant"><svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1 5h12M9 1l4 4-4 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
            $galArrows.append(arrPrev).append(arrNext);
        }

        // sous 992px : un slider slick pilote par les fleches et le compteur
        var $galMob = $('.js-cabGalRows');
        function cabGalMobile() {
            if (!$galMob.length) { return; }
            var $slider = $galMob.find('.page-cabinet-gal-row').eq(0);
            if ($(window).width() < 992) {
                if (!$galMob.hasClass('mob')) {
                    $galMob.addClass('mob');
                    // toutes les photos dans une seule rangee
                    $galMob.find('.page-cabinet-gal-row').not($slider).children().appendTo($slider);
                    $slider.on('init afterChange', function (e, slick, cur) {
                        var i = (cur === undefined) ? slick.currentSlide : cur;
                        $galCnt.find('span').eq(0).text(i + 1);
                    });
                    $slider.slick({
                        arrows: true,
                        dots: false,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        prevArrow: $('.js-cabGalPrev'),
                        nextArrow: $('.js-cabGalNext')
                    });
                }
            }
        }
        cabGalMobile();
        $(window).on('resize', cabGalMobile);

        // desktop : les fleches inversent le sens de defilement des rangees
        $(document).on('click', '.js-cabGalPrev, .js-cabGalNext', function () {
            if ($(window).width() < 992) { return; }
            var to = $(this).hasClass('prev') ? 'right' : 'left';
            $galRows.each(function (i) {
                var $row = $(this);
                var dir = (i % 2 === 0) ? to : (to === 'left' ? 'right' : 'left');
                if ($row.data('marquee-dir') === dir) { return; }
                $row.marquee('destroy');
                $row.marquee({
                    startVisible: true, duration: 25000, gap: 0, delayBeforeStart: 0,
                    direction: dir, duplicated: true, duplicateCount: 3, pauseOnHover: true
                });
                $row.data('marquee-dir', dir);
            });
        });

        // modale : fleches et numeros de photo vont dans la barre sous le cadre
        $('.js-cabGalModalSlider').slick({
            arrows: true,
            dots: true,
            slidesToShow: 1,
            appendArrows: $('.js-cabGalModalNav'),
            appendDots: $('.js-cabGalModalNav'),
            customPaging: function (slider, i) {
                return '<button type="button">' + (i + 1) + '</button>';
            },
            prevArrow: '<button type="button" class="arrow prev-arrow" aria-label="Précédent"><svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13 5H1M5 1L1 5l4 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="arrow next-arrow" aria-label="Suivant"><svg viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1 5h12M9 1l4 4-4 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        });

        $(document).on('click', '.js-cabGalImg', function () {
            $('.js-cabGalModalSlider').slick('slickGoTo', $(this).data('img'), true);
            $('.js-cabGalModal').addClass('active');
            $('body').css('overflow', 'hidden');
        });

        $(document).on('click', '.js-cabGalModalCls', function () {
            $('.js-cabGalModal').removeClass('active');
            $('body').css('overflow', '');
        });

        $(document).keyup(function (e) {
            if (e.key === 'Escape') { $('.js-cabGalModalCls').eq(0).trigger('click'); }
        });
    });
    /*page cabinet — galerie*/

    /*scroll sidebar*/
    /*$(window).on('load resize', function(){
        if ($('.js-pageTextSide').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-pageTextSide').offset().top;
                var singleSidebarRailTop = $('.js-pageTextSideRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-pageTextSide').outerHeight();
                var singleSidebarMenuH = $('.js-pageTextSideMenu').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-pageTextSideRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-pageTextSideRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 30;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-pageTextSideMenu').css('top', '0')
                    }
                })
            } else {
                $('.js-pageTextSideRail').css('height', 'auto')
            }
        }
    })*/
    /*scroll sidebar*/

    /*page faq*/
    /*$('.js-pageFaqCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageFaqListItem').slideDown();
        } else if ($('.js-pageFaqCat.active').data('id') === 'all') {
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').slideUp();
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageFaqListItem').slideUp();
            $('.js-pageFaqListItem').removeClass('opened');
            $('.js-pageFaqListItem[data-id="'+id+'"]').slideDown();
            $('.js-pageFaqListItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageFaqCat').removeClass('active')
        $(this).addClass('active')


        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $('.js-pageFaqListItem.opened .js-pageFaqListBurg').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgWrap').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgTxt').eq(0).slideDown()
    })
    $('.js-pageFaqListBurg').click(function(){
        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $(this).addClass('active')
        $(this).closest('.js-pageFaqListBurgWrap').addClass('active')
        $(this).siblings('.js-pageFaqListBurgTxt').slideDown()
    })*/
    /*page faq*/

}( jQuery ) );